import { render, staticRenderFns } from "./contractstage.vue?vue&type=template&id=2e88d1f8&"
import script from "./contractstage.vue?vue&type=script&lang=js&"
export * from "./contractstage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports